
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparisons/dropbox-replay-vs-frame-io",
      function () {
        return require("private-next-pages/comparisons/dropbox-replay-vs-frame-io.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparisons/dropbox-replay-vs-frame-io"])
      });
    }
  